import { useGetLaunchedCampaignsQuery } from '../endpoints/launched-campaigns.endpoints';

export function useNewCampaignRequestCount() {
  const { data } = useGetLaunchedCampaignsQuery(
    { status: 'new', page: 1, page_size: 1 },
    { pollingInterval: 60_000 },
  );

  return data?.total_objects ?? 0;
}
